/* @flow */

// import xhr from 'axios';
import { DIRETORIO_IMAGENS_UPLOAD } from '../../utils/constants';
import { type Empresa } from '../../empresa/types';

const viewEmpresa = (empresa: Empresa) => `
    <div class="m-card-profile">
        ${empresa.logo ? `
            <div class="m-card-profile__pic">
                <div class="m-card-profile__pic-wrapper">
                    <div class="m-card-profile__pic-mask">
                        <a href="${DIRETORIO_IMAGENS_UPLOAD}${empresa.logo}" download="logo.png" target="_blank">
                            <img src="${DIRETORIO_IMAGENS_UPLOAD}${empresa.logo}" alt="Logo" />
                        </a>
                    </div>
                </div>
            </div>
        ` : ''}
        <div class="m-card-profile__details">
            <span class="m-card-profile__name">${empresa.fantasia}</span>
            <span class="m-card-profile__email">${empresa.razaoSocial}</span><br>
            <span class="m-card-profile__name">${empresa.representante}</span>
            <span class="m-card-profile__email">${empresa.tipo}</span><br>
            <span class="m-card-profile__email">${empresa.cnpj}</span><br>
        </div>
    </div>
`;

export default viewEmpresa;
